






































































































































import {State, Getter, Action, namespace} from 'vuex-class'
import {Vue, Prop, Component, Watch} from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import {IPatient} from '@/store/modules/views/patient/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {ELevel} from '@/services/Menus'
import {UserProfile} from '@/store/modules/views/userProfile/states'

@Component
export default class EditPatientDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editPatientDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editPatientAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {
    return this.nameValidate(this.firstname)
      && this.nameValidate(this.lastname)
      && this.cidValidate()
      && this.phoneValidate()
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private patient!: IPatient & { roles: string[], permissions: string[], accounts: string[] }
  private loading = false

  @Getter('components/prefixNames')
  private prefixNames: string[]

  private prefix: string = ''

  @Getter('map/getMapPatientLocation')
  private patientMapData!: { lat: number; lon: number, address: string }
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private activePicker = null
  private valid = false
  private firstname = ''
  private lastname = ''
  private phoneNumber = ''
  private cid = ''
  private sosPhoneNumber = ''
  private disease = ''
  private drugAllergy = ''
  private hospital = ''
  private center = ''
  private date = null
  private menu = false
  private snackbar = false
  private address = ''
  private useritems = ''
  private userId = ''

  private patientTypeitems = ''
  private map = {
    lat: 0,
    lon: 0,
  }

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  private location: IPatient['address'] = {address: ''}

  get centerLists() {
    return this.centerItemLists
  }

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  @Getter('patient/patientTypeLists')
  private patientTypeItemLists!: () => void

  @Getter('user/userLists')
  private userItemLists!: () => [{ name: any, value: any }]

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  get userLists() {
    const map = _.map(this.userItemLists, (item: { name: any, value: any }) => {
      return {
        name: item.name,
        value: item.value,
      }
    })
    return map
  }

  @Action('patient/getPatientTypeById')
  private getPatientTypeById!: (options: {}) => void

  @Action('patient/putPatient')
  private putPatient!: (options: {}) => void

  @Action('user/getUserListByLevel')
  private getUserList!: () => void

  get patientTypeLists() {
    return this.patientTypeItemLists
  }

  public async getPatientTypes() {
    await this.getPatientTypeById({id: this.patient._id})
  }

  private async getPatientTypeListFunc() {
    await this.getPatientTypeList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: 'score',
        sortDesc: true,
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private changeDateType() {
    this.menu = false
  }

  private async created() {
    this.firstname = this.patient.firstname || ''
    this.lastname = this.patient.lastname || ''
    this.cid = this.patient.idCard || ''
    this.phoneNumber = this.patient.phone || ''
    this.sosPhoneNumber = this.patient.sosPhone || ''
    this.disease = this.patient.disease || ''
    this.drugAllergy = this.patient.drugAllergy || '',
    this.hospital = this.patient.hospital || '',
    this.address = this.patient.address.address || '',
    this.date = this.patient.birthdate || '',
    this.map = this.patient.map,
    this.location = this.patient.address,
    this.patientTypeitems = this.patient.patientTypeId,
    // this.center = this.patient.centerId || ''
    this.useritems = this.patient.userId || ''
    this.prefix = this.patient.prefix || ''
    await Promise.all([
      this.getPatientTypes(),
      this.getPatientTypeListFunc(),
      this.getCenterListFunc(),
      this.getUserFunc(),
    ])
  }

  private requireSelect(value) {
    return [(v) => !!v || 'จำเป็นต้องเลือก']
  }

  private requireInput(value) {
    return value !== '' || 'จำเป็นต้องกรอก'
  }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${year ? year + 'ปี ' : ''}${month}เดือน`
  }

  private cidValidate() {
    return /^[0-9]{13}$/.test(
        this.cid) || false
  }

  private phoneValidate() {
    return /^(0|66|\+66)[1-9]{1}[0-9]{7,8}$/.test(
        this.phoneNumber) && this.sosPhoneNumber || false
  }

  private async editPatientAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      try {
        await this.putPatient({
          id: this.patient._id,
          userId: this.level.mode === ELevel.USER ? this.profile._id : this.useritems,
          centerId: this.center,
          prefix: this.prefix,
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phoneNumber,
          patientTypeId: this.patientTypeitems,
          idCard: this.cid,
          address: {address: this.address, ...this.location},
          map: this.map,
          sosPhone: this.sosPhoneNumber,
          birthdate: this.date,
          drugAllergy: this.drugAllergy,
          disease: this.disease,
          hospital: this.hospital,
        })
        this.updateSnackbar({txt: 'แก้ไขผู้สูงอายุ/ผู้ป่วย', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
        return false
      }
    } else {
      return false
    }
  }

  private async getCenterListFunc() {
    await this.getCentertList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private async changeUser() {
    if (this.useritems != null) {
      this.userId = this.useritems
    }
    this.menu = false
  }

  private async getUserFunc() {
    if (this.level.mode !== ELevel.USER) {
      await this.getUserList()
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  @Watch('menu')
  private birthdate(val) {
    if (val) {
      setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }
}
